<template>
    <div class="verify-email-root p-4 d-flex flex-column align-items-center">
        <div class="primary-color">
            <BaseIcon name="envelope" size="6x" />
        </div>
        <h4 class="headline">
            {{ $t('shared.loginModule.verifyEmail.verifyYourEmail') }}
        </h4>
        <h6 class="subtitle">
            {{ $t('shared.loginModule.verifyEmail.weSentAnEmailTo') }}
        </h6>
        <h6 class="subtitle">{{ email }}</h6>

        <h6 class="subtitle text-center transp-3 mt-4">
            {{ $t('shared.loginModule.emailVerificationTip') }}
        </h6>
        <h6 class="subtitle text-center transp-3">
            {{ $t('shared.loginModule.noEmail') }}
        </h6>
        <BaseButton @click="goToLogIn" variant="primary">
            {{ $t('shared.loginModule.verifyEmail.continueToSignIn') }}
        </BaseButton>
        <BaseButton
            class="mt-2"
            v-if="!newEmailConfirmationSent"
            variant="text"
            @click="sendEmailVerification"
        >
            {{ $t('shared.loginModule.verifyEmail.resendEmail') }}
        </BaseButton>
        <div
            v-else-if="isSendingEmail"
            class="d-flex justify-content-center my-2"
        >
            <Spinner class="primary-color" />
        </div>
        <div v-else class="my-2">
            <h6 class="text-center subtitle bold">
                {{ $t('shared.loginModule.verifyEmail.newEmailSent') }}
            </h6>
        </div>
    </div>
</template>

<script>
import states from '../states';
import { emailVerificationURL } from '~/utils/urlUtils';

export default {
    name: 'VerifyEmail',
    props: {
        email: {
            type: String,
            require: true,
        },
    },
    data: () => ({
        newEmailConfirmationSent: false,
        isSendingEmail: false,
    }),
    methods: {
        async sendEmailVerification() {
            this.newEmailConfirmationSent = true;
            this.isSendingEmail = true;
            await this.$interfaces.user.email.confirm
                .post({
                    body: {
                        email: this.email,
                        returnUrl: emailVerificationURL(),
                    },
                })
                .finally(() => {
                    this.isSendingEmail = false;
                });
        },
        goToLogIn() {
            // console.log('Going to login');
            this.$emit('stateChange', states.LOGIN);
        },
    },
    mounted() {
        // Reset the value
        this.newEmailConfirmationSent = false;
    },
};
</script>

<style scoped>
.verify-email-root {
    background-color: white;
    border-radius: 4px;
}
</style>
